import { Component, Injector, OnInit } from '@angular/core';
import { BaseDialog } from "../../admin-panel/BaseDialog";

@Component({
    selector: '[app-set-payed-till-dialog]',
    templateUrl: './set-payed-till-dialog.component.html',
    styleUrls: ['./set-payed-till-dialog.component.css'],
    standalone: false
})

export class SetPayedTillDialogComponent extends BaseDialog implements OnInit {
  public PayedTill = 0;

  ngOnInit()
  {
  }

}
